class ProductController extends AbstractEntityEditController
	@register()
	@inject '$q',
		'$uibModal'
		'$scope'
		'$window'

		'product'
		'priceRegions'
		'reasonCodes'
		'parseBool'
		'stockValues'
		'units'
		'vatRates'
		'productFilters'
		'suppliers'
		'stockLocations'
		'isInABundle'

		'EntityAttributeService'
		'ConfigurationService'
		'MessageTerminal'
		'ReasonCodeService'
		'ProductEditingService'
		'ProductSuggestionService'
		'ProductDuplicateSkuService'
		'ToastService'
		'Guid'
		'translate'

		'ProductCategoryRepository'
		'ProductRepository'
		'ProductFilterRepository'
		'ShopRepository'
		'ShopGroupRepository'

		'ACCOUNTING_CATEGORIES'
		'DEFAULT_PRODUCT_DATA_LABEL'
		'BACKEND_PRODUCT_ENTITY_TYPE'
		'BACKEND_SHOP_GROUP_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.product'
		@mainCrud.entityTitle = 'wbo.new.product'
		@mainCrud.isNewEntity = true

		@setConfigurations()
		@searchData =
			addons: []
			bundles: []
			filters: []
			suggestions: []

		@productTypes = [
			{
				id: @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT
				name: @translate('general.product.type.products')
				enabled: true
			}
			{
				id: @BACKEND_PRODUCT_ENTITY_TYPE.ADDON
				name: @translate('general.product.type.addonproduct')
				enabled: @isAddonsEnabled
			}
			{
				id: @BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE
				name: @translate('general.product.type.bundleproduct')
				enabled: @isBundleEnabled
			}
			{
				id: @BACKEND_PRODUCT_ENTITY_TYPE.DEPOSIT
				name: @translate('general.product.type.depositproduct')
				enabled: true
			}
			{
				id: @BACKEND_PRODUCT_ENTITY_TYPE.NON_STOCK
				name: @translate('general.product.type.nonstockproduct')
				enabled: true
			}
		]

		@productTypes = @productTypes.filter (type) =>
			return @parseBool(type.enabled)

		@filteredReasonCodes = @ReasonCodeService.getGroupedReasonCodes(@reasonCodes)
		@stockValuesToRemove = []

		@productsWithDuplicateSkus = {}

		@productSuggestionRecommendationCount = 3

		if @product.id?
			@mainCrud.isNewEntity = false
			@mainCrud.entityTitle = @product.name
			@kibanaSalesUrl = @product.kibana_sales_url

			if !_.find(@productTypes, {id: @product.entity_type})
				key = 'general.product.type.' + @product.entity_type.toLowerCase()
				@productTypes.push {
					id: @product.entity_type
					name: @translate(key)
				}

			if @product.product_filters.length > 0
				@product.product_filters = @mapProductFilterNames(@product.product_filters)

			# Map separately loaded stock values to product
			angular.forEach @stockValues, (stockValue) =>
				if _.isEmpty(stockValue.product_variant_id)
					@product.stock_values ?= []
					@product.stock_values.push(stockValue)

					return

				productVariant = _.find(@product.product_variants, {id: stockValue.product_variant_id})

				if _.isEmpty(productVariant)
					return

				productVariant.stock_values ?= []
				productVariant.stock_values.push(stockValue)

			# All product_data entities will have same variable_price and unit_id
			@hasVariablePrice = @product.product_data[0]?.variable_price == '1' ? false
			@unitId = @product.product_data[0]?.unit_id ? 'pc'

			# New product variant object mock used to dynamically add variants for product
			@newVariant = @getNewProductVariant()
			@productVariantExternalAttributesInit @newVariant

			@onSkuChange()

		else
			@product =
				name: ''
				image: null
				active: "1"
				offline_product: "1"
				entity_type: @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT
				product_variants: []
				product_filters: []
				product_suggestions: []
				addon_products: []
				bundled_products: []
				product_data: []
				product_categories: []
				product_images: []
				product_skus: []

			@hasVariablePrice = false
			@unitId = @getDefaultUnit().id

		@resetNewProductVariant()
		@setSuppliers()

		@deletedImagesIds = []
		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity(
			@product,
			'BACKEND_PRODUCT_ATTRIBUTE_TYPE',
			{
				exclude_from_ordering_suggestion: '0'
				print_receipt: '0'
				exclude_from_discounts: '0'
				should_ask_quantity: '0'
				should_ask_for_vat: null
				hide_from_web: '0'
				hide_in_self_checkout: '0'
				requires_preparation: '0'
				age_restriction: null
				block_in_self_checkout: '0'
				serial_number_required: '0'
				sell_on_commission: '0'
				can_be_returned_to_supplier: '0'
				unit_id_base: null
				unit_id_actual: null
				unit_amount: null
				number_in_package: null
				carbon_footprint: null
			}
		)

		@initAccountingCategories()
		@processAgeRestrictionDescription()

		if !_.isEmpty(@product.product_variants)
			for variant in @product.product_variants
				@productVariantExternalAttributesInit variant

		@initUnitData()
		@initAddonProducts()
		@initBundleProducts()
		@initDepositProducts()
		@initProductSuggestions()
		@checkProductStockStatus()

		if @stocksEnabled
			@stockProcessor()

		@tabs = [
			{
				title: 'wbo.product.tabs.details'
				selector: '#tab-product-details'
			}
			{
				title: 'wbo.product.variants'
				selector: '#tab-product-variants'
				disabled: @isVariantsTabDisabled()
			}
			{
				title: 'wbo.product.tabs.addons'
				selector: '#tab-product-addons'
				disabled: @isAddonsTabDisabled()
			}
			{
				title: 'wbo.product.tabs.bundle'
				selector: '#tab-product-bundle'
				disabled: @isBundledProductsTabDisabled()
			}
			{
				title: 'wbo.product.tabs.filter'
				selector: '#tab-product-filter'
				disabled: @isProductFilterTabDisabled()
			}
			{
				title: 'wbo.product.tabs.suggestion'
				selector: '#tab-product-suggestion'
				disabled: @isProductSuggestionTabDisabled()
			}
		]

		@refreshActionButtons()

		# Triggers on main image deletion too
		@MessageTerminal.on @$scope, @MessageTerminal.events.GALLERY.EDIT, => @main_form.$setDirty true
		# This is not triggered for main image as it's never actually deleted, just image removed
		@MessageTerminal.on @$scope,
			@MessageTerminal.events.GALLERY.DELETE,
			(image) =>
				@main_form.$setDirty true

				if !image.is_new
					@deletedImagesIds.push image.id

	save: ->
		if @hasMissingProductData()
			promise = @$uibModal
				.open
					templateUrl: '@app/product/modals/product.missing-product-data.confirm.modal.view.html'
					controller: 'MissingProductDataModalController'
					controllerAs: 'missingProductDataModal'
					bindToController: true
					resolve:
						product: @product
				.result
				.catch (e) =>
					@mainCrud.saving = false

					throw e
		else
			promise = @ProductRepository.resolve()

		promise.then =>
			@ProductEditingService
				.saveEntity(@)
				.then (response) =>
					@stockProcessor()
					@afterSave(response)
					@sortProductSuggestions()
				.catch (response) =>
					@handleErrors(response)

	hasMissingProductData: ->
		if _.isEmpty(@product.product_data)
			return true

		if !_.isEmpty(@product.product_variants)
			return _.some(@product.product_variants, (variant) -> _.isEmpty(variant.product_data))

	afterSave: (response) ->
		@product.id ?= response.data.id

		super(response)

		# Reload page to show new variant ID's for Incremental ID feature
		if @isIncrementalIdEnabled && _.filter(@product.product_variants, {id: null}).length > 0
			@$window.location.reload()

	delete: ->
		@deleteEntity(@ProductRepository, @product)

	setSuppliers: ->
		if !_.isEmpty(@product.supplier_id)
			@product.supplier = _.find(@suppliers, {id: @product.supplier_id})

		if !_.isEmpty @product.product_variants
			for variant in @product.product_variants
				if !_.isEmpty(variant.supplier_id)
					variant.supplier = _.find(@suppliers, {id: variant.supplier_id})

	onProductDataChange: ->
		@main_form.$setDirty true

	onTypeChange: ->
		@hasVariablePrice = false

		@toggleTabs()
		@checkProductStockStatus()
		@showUnitPricing()

		switch true
			when @isAddonProduct() then @onAddonSwitch()
			when @isBundleProduct() then @onBundleSwitch()
			when @isDepositProduct() then @onDepositSwitch()
			when @isNonStockProduct() then @onNonStockSwitch()

	onNonStockSwitch: ->
		@attributesService.setAttribute 'exclude_from_discounts', '1'
		@attributesService.setAttribute 'should_ask_quantity', '0'
		@attributesService.setAttribute 'exclude_from_ordering_suggestion', '1'
		@attributesService.setAttribute 'can_be_returned_to_supplier', '0'
		@attributesService.setAttribute 'sell_on_commission', '0'
		@attributesService.setAttribute 'serial_number_required', '0'
		@attributesService.setAttribute 'block_in_self_checkout', '1'

	onAddonSwitch: ->
		@attributesService.setAttribute 'hide_from_web', '0'
		@attributesService.setAttribute 'hide_in_self_checkout', '0'
		@attributesService.setAttribute 'print_receipt', '0'
		@attributesService.setAttribute 'block_in_self_checkout', '0'
		@attributesService.setAttribute 'exclude_from_ordering_suggestion', '0'
		@attributesService.setAttribute 'serial_number_required', '0'

	onBundleSwitch: ->
		@unitId = @getDefaultUnit().id

	onDepositSwitch: ->
		@unitId = @getDefaultUnit().id
		@attributesService.setAttribute 'age_restriction', null
		@attributesService.setAttribute 'hide_from_web', '0'
		@attributesService.setAttribute 'hide_in_self_checkout', '0'
		@attributesService.setAttribute 'print_receipt', '0'
		@attributesService.setAttribute 'block_in_self_checkout', '0'
		@attributesService.setAttribute 'exclude_from_ordering_suggestion', '1'
		@attributesService.setAttribute 'exclude_from_discounts', '1'
		@attributesService.setAttribute 'should_ask_quantity', '0'
		@attributesService.setAttribute 'serial_number_required', '0'
		@attributesService.setAttribute 'can_be_returned_to_supplier', '0'
		@attributesService.setAttribute 'sell_on_commission', '0'

	isAddonProduct: ->
		return @product.entity_type == @BACKEND_PRODUCT_ENTITY_TYPE.ADDON

	isBundleProduct: ->
		return @product.entity_type == @BACKEND_PRODUCT_ENTITY_TYPE.BUNDLE

	isDepositProduct: ->
		return @product.entity_type == @BACKEND_PRODUCT_ENTITY_TYPE.DEPOSIT

	isNonStockProduct: ->
		return @product.entity_type == @BACKEND_PRODUCT_ENTITY_TYPE.NON_STOCK

	setConfigurations: ->
		isEnabled = (key) =>
			return @ConfigurationService.isEnabled(key)

		@mainCrud.showDelete = isEnabled('Backoffice.ProductManagement.Products.EnableProductDeletion')
		@mainCrud.showCreate = isEnabled('Backoffice.ProductManagement.Products.EnableProductCreation')
		@mainCrud.showUpdate = isEnabled('Backoffice.ProductManagement.Products.EnableProductEdit')

		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@accountingCategoriesEnabled = isEnabled('Shared.Setting.AccountingCategories.Enabled')
		@stocksEnabled = isEnabled('Backoffice.ProductManagement.Products.EnabledAddStockCountOnCreate')
		@isOrdinEnabled = isEnabled('Backoffice.Setting.Integrations.EnableOrdin')
		@isAddonsEnabled = isEnabled('Backoffice.ProductManagement.Products.EnableProductAddons')
		@isBundleEnabled = isEnabled('Backoffice.ProductManagement.Products.EnableBundleProducts')
		@isVariantsEnabled = isEnabled('Backoffice.ProductManagement.Products.EnableProductVariantCreation')
		@isProductFilterEnabled = isEnabled('Shared.Setting.ProductFilter.Enabled')
		@isUnitPricingEnabled = isEnabled('Shared.Setting.ProductUnitPricing.Enabled')
		@isShopGroupVisible = isEnabled('Backoffice.ShopManagement.Shops.EnableShopGroups')
		@isAllShopSelectionEnabled = isEnabled('Backoffice.Setting.SelectAllShopsForProducts.Enabled')
		@showVariantPrices = isEnabled('Backoffice.ProductManagement.Products.ShowProductVariantPrices')
		@enableVariantDeletion = isEnabled('Backoffice.ProductManagement.Products.EnableProductVariantDeletion')
		@isSellOnCommissionEnabled = isEnabled('POS.Setting.SellOnCommission.Enabled')
		@isReturnToSupplierEnabled = isEnabled('Shared.Setting.ReturnToSupplier.Enabled')
		@isAskForVatEnabled = isEnabled('Shared.Setting.AskForVatWhenSold.Enabled')
		@isMultipleSkuEnabled = isEnabled('Shared.Setting.Product.MultipleSku.Enabled')
		@isIncrementalIdEnabled = isEnabled('Shared.Core.IncrementalId.Product.Enabled')
		@isProductCategoryRequired = isEnabled('Shared.Setting.ProductCategoryRequired.Enabled')

	findCategories: (name) ->
		@ProductCategoryRepository.searchCategories name

	checkAddonAmounts: (addon) ->
		setValidity = (fieldName, isValid) =>
			field = @addons_form["addons[#{addon.id}][#{fieldName}]"]

			field.$setValidity 'quantity', isValid
			field.$setTouched() if isValid

			addon.error = if !isValid then @translate('wbo.product.addons.amounts.error') else null

		setValidity('min', true)
		setValidity('max', true)
		setValidity('initial', true)

		globalMax = if @product.max_addons_quantity then parseInt @product.max_addons_quantity else Number.MAX_VALUE
		min = if addon.min? then parseInt addon.min else 0
		max = if addon.max? then parseInt addon.max else globalMax
		initial = if addon.initial? then parseInt addon.initial else min

		setValidity('min', false) if min < 0 || min > max
		setValidity('max', false) if min > max
		setValidity('initial', false) if min > initial || initial > max

		if addon.default_product_variant_id? && !addon.initial?
			setValidity('initial', false)
			addon.error = @translate('wbo.product.addons.amounts.error.variant_required')

		if @addonProducts[addon.product_id].product_variants.length > 0 && !addon.default_product_variant_id? && addon.initial?
			setValidity('initial', false)
			addon.error = @translate('wbo.product.addons.amounts.error.initial_required')

	resetNewProductVariant: ->
		@newVariant = @getNewProductVariant()

		@productVariantExternalAttributesInit @newVariant

		if @isUnitPricingEnabled && angular.isDefined @ProductUnitDataModalService
			@ProductUnitDataModalService.newVariant = @newVariant
			@ProductUnitDataModalService.initializeUnitData()
			@ProductUnitDataModalService.handleDataChanges()
			@ProductUnitDataModalService.persistData()

	getNewProductVariant: ->
		return {
			id: if @isIncrementalIdEnabled then null else @Guid.generate()
			is_template: true
			product_variant_name: ''
			sku: null
			product_data: []
			stock_values: angular.copy @initialStocksForVariant
			supplier: @product.supplier
			product_variant_skus: []
			is_new: true
		}

	addVariant: ->
		if !@product.product_variants?
			@product.product_variants = []

		# Reset to null
		@newVariant.attributeService.persistAttributes()
		variant = _.clone @newVariant
		variant.attributeService.setEntity(
			variant,
			'BACKEND_PRODUCT_VARIANT_ATTRIBUTE_TYPE'
		)

		delete variant.is_template

		if variant.sku == ''
			variant.sku = null

		@product.product_variants.push variant

		@resetNewProductVariant()

		@separate_form.$setDirty true
		@separate_form.$setPristine()
		@separate_form.$setUntouched()
		@checkProductStockStatus()

	deleteVariant: (variant) ->
		angular.forEach(
			variant.stock_values,
			(stockValue) =>
				stockValue.name = @product.name + ' ' + variant.product_variant_name
				stockValue.sku = variant.sku
		)

		@stockValuesToRemove.push(variant.stock_values)
		@product.product_variants = _.without(@product.product_variants, variant)
		@setFormsDirty()
		@checkProductStockStatus()

	checkProductStockStatus: ->
		@showProductStocks = @stocksEnabled &&
			!@isBundleProduct() &&
			!@isAddonProduct() &&
			!@isDepositProduct() &&
			!@isNonStockProduct()
		@showVariantStocks = @stocksEnabled && !@isBundleProduct() && !@isAddonProduct() && !@isNonStockProduct()

	addSku: (product) ->
		@setFormsDirty()

		@ProductRepository
			.generateSku()
			.then (response) =>
				product.sku = response.data
				@onSkuChange()

	initDepositProducts: ->
		if !@canHaveDepositProduct()
			return

		query = @ProductRepository.createQuery()
		query.criteria 'entity_type', '=', @BACKEND_PRODUCT_ENTITY_TYPE.DEPOSIT

		@ProductRepository
			.findByQuery query
			.then (response) =>
				@depositProducts = _.indexBy response.data, 'id'

	canHaveDepositProduct: ->
		return @product.entity_type == @BACKEND_PRODUCT_ENTITY_TYPE.PRODUCT

	# Addon products
	initAddonProducts: ->
		@addonProducts = {}

		if !@product || @product.addon_products.length == 0
			return

		productIds = _.pluck(@product.addon_products, "product_id")
		query = @ProductRepository.createQuery()
		query.criteria 'id', 'IN', productIds.join()
		query.with 'product_variants'

		@ProductRepository
			.findByQuery query
			.then (response) =>
				@addonProducts = _.indexBy response.data, "id"

				for addon in @product.addon_products
					if !@addonProducts[addon.product_id]?
						@product.addon_products = _.reject @product.addon_products, {id: addon.id}

						continue

					if addon.default_product_variant_id?
						addonProduct = _.find(@addonProducts, {id: addon.product_id})

						if addonProduct?
							addon.default_product_variant_id = null if !_.find(addonProduct.product_variants, {id: addon.default_product_variant_id})?

					@checkAddonAmounts(addon)

	searchAddonProducts: (term) ->
		@ProductRepository
			.searchAddonProducts term, @product.addon_products
			.then (response) =>
				@searchData.addons = response

	addNewAddonProduct: (selectedProduct) ->
		selectedProduct.$wmSelectHidden = true
		@addonProducts[selectedProduct.id] = selectedProduct
		@product.addon_products.push(
			id: @Guid.generate()
			product_id: selectedProduct.id
			min:null
			max: null
			initial: null
			default_product_variant_id: null
			is_new: true
		)

	removeAddonProduct: (addon) ->
		_.find(@searchData.addons, {id: addon.product_id})?.$wmSelectHidden = false

		@product.addon_products = _.without(@product.addon_products, addon)
		@setFormsDirty()

	canHaveAddonProducts: () ->
		return !@isAddonProduct() && !@isBundleProduct() && !@isDepositProduct() && !@isNonStockProduct()

	isAddonsTabDisabled: () ->
		return !@isAddonsEnabled || !@canHaveAddonProducts() || @isNonStockProduct()

	# Bundle products
	initBundleProducts: ->
		if !@product || @product.bundled_products.length == 0
			return

		productIds = _.pluck(@product.bundled_products, 'product_id')
		query = @ProductRepository.createQuery()
		query.criteria 'id', 'IN', productIds.join()
		query.with 'product_variants'

		@ProductRepository
			.findByQuery query
			.then (response) =>
				products = _.indexBy response.data, 'id'
				for bundledProduct in @product.bundled_products
					bundledProduct.name = products[bundledProduct.product_id].name
					bundledProduct.product_variants = products[bundledProduct.product_id].product_variants

	searchProductsForBundle: (searchString) ->
		@ProductRepository
			.searchProductsForBundle searchString
			.then (response) =>
				@searchData.bundles = response

	addProductToBundle: (selectedProduct) ->
		selectedProduct.$wmSelectHidden = true
		@product.bundled_products.push(
			id: @Guid.generate()
			name: selectedProduct.name
			product_id: selectedProduct.id
			product_variant_id: null
			product_variants: selectedProduct.product_variants
			quantity: 1
			is_new: true
		)

	getProductName: (product) ->
		return _.unescape product.name

	removeProductFromBundle: (bundledProduct) ->
		_.find(@searchData.bundles, {id: bundledProduct.product_id})?.$wmSelectHidden = false

		@product.bundled_products = _.without(@product.bundled_products, bundledProduct)
		@setFormsDirty()

	checkBundledProductQuantity: (bundledProduct, min = 1) ->
		@main_form.$setValidity('minQuantity', bundledProduct.quantity >= min)

	canHaveBundledProducts: ->
		return !@isAddonProduct() && @isBundleProduct() && !@isDepositProduct()

	isBundledProductsTabDisabled: ->
		return !@canHaveBundledProducts() || !@isBundleEnabled || @isNonStockProduct()

	isProductFilterTabDisabled: ->
		return !@isProductFilterEnabled || @isAddonProduct() || @isDepositProduct()

	isProductSuggestionTabDisabled: ->
		return @isAddonProduct() || @isDepositProduct()

	# Product filters
	addProductFilter: (selectedFilter) ->
		selectedFilter.$wmSelectHidden = true

		@product.product_filters.push({
			product_id: @product.id
			product_filter_id: selectedFilter.id
			value: selectedFilter.value
			name: selectedFilter.name
		})

	searchProductFilter: (searchString) ->
		@ProductFilterRepository
			.searchProductFilters searchString, @product.product_filters
			.then (response) =>
				@searchData.filters = response

	removeProductFilter: (productFilter) ->
		_.find(@searchData.filters, {id: productFilter.product_filter_id})?.$wmSelectHidden = false

		@product.product_filters = _.without(@product.product_filters, productFilter)
		@setFormsDirty()

	# Accounting categories implementation (mostly for Norway users)
	initAccountingCategories: ->
		if !@accountingCategoriesEnabled
			return

		@accountingCategories = @ACCOUNTING_CATEGORIES.DATA

		categoryId = @attributesService.attributes.accounting_category_id

		if categoryId?
			@currentAccountingCategory = _.find(@accountingCategories, {id: categoryId.value})
		else
			@currentAccountingCategory = _.find @accountingCategories, {id: @ACCOUNTING_CATEGORIES.DEFAULT.OTHER}
			@assignCurrentAccountingCategory()

	assignCurrentAccountingCategory: ->
		@attributesService.setAttribute 'accounting_category_id', @currentAccountingCategory.id
		@attributesService.setAttribute 'accounting_category_name', @currentAccountingCategory.name

	findShops: (name) ->
		@ShopRepository.searchShops name

	findShopGroups: (searchString) ->
		query = @ShopGroupRepository.createQuery()
		query.criteria 'name', 'LIKE', searchString
		query.criteria 'entity_type', '=', @BACKEND_SHOP_GROUP_ENTITY_TYPE.PRODUCT_SHOP_GROUP

		@ShopGroupRepository.findByQuery query

	stockProcessor: ->
		@newVariant.stock_values = []
		@processStockValues(@newVariant, true)
		@initialStocksForVariant = angular.copy(@newVariant.stock_values)

		@processStockValues(@product)

		angular.forEach @product.product_variants, (productVariant) =>
			@processStockValues(productVariant, true)

	###
		Processes product stock values
		adds initial stock value object for product on missing stock locations
		extends stock value object adding related stock location name
		resets primary stock values collection to the new one, with filtered and sorted values.
	###
	processStockValues: (product, isVariant = false) ->
		newStockValues = []

		angular.forEach @stockLocations, (location) =>
			if angular.isUndefined product.stock_values
				product.stock_values = []

			result = _.findWhere(product.stock_values, {stock_location_id: location.id})

			if !result?
				result =
					id: null
					product_id: if angular.isDefined @product.id then @product.id else null
					product_variant_id: if isVariant && angular.isDefined(product.id) then product.id else null
					stock_location_name: location.name
					quantity: 0.toFixed(3)
					min_quantity: 0.toFixed(3)
					delta_quantity: 0.toFixed(3)
					stock_location_id: location.id
					reason_code_id: null
					shelf: null
					isNew: true
					is_included_in_ordering_suggestion_report: true
			else
				result = angular.extend(
					result,
					{
						reason_code_id: null
						stock_location_name: location.name
						quantity: parseFloat(result.quantity || 0).toFixed(3)
						min_quantity: parseFloat(result.min_quantity || 0).toFixed(3)
						delta_quantity: 0.toFixed(3)
						isNew: false
						is_included_in_ordering_suggestion_report: @parseBool(result.is_included_in_ordering_suggestion_report)
					}
				)

			@setReasonCodes(result)
			newStockValues.push result

		product.stock_values = _.sortBy(newStockValues, 'stock_location_name')

	setReasonCodes: (stock) ->
		if parseFloat(stock.delta_quantity || 0) == 0
			stock.possibleReasonCodes = @filteredReasonCodes.neutral
		else
			deltaType = if parseFloat(stock.delta_quantity || 0) < 0 then 'negative' else 'positive'

			stock.possibleReasonCodes = @filteredReasonCodes[deltaType]

	getHighestAgeRestrictionCategory: ->
		if @product.product_categories.length
			return _.max @product.product_categories, (category) -> category.age_restriction
		return null

	processAgeRestrictionDescription: ->
		@ageRestrictionDescription = ""
		ageRestrictionAttribute = @attributesService.attributes.age_restriction?.value

		if ageRestrictionAttribute?
			@ageRestrictionDescription = @translate('product.age_restriction.description')
			return

		ageRestrictionCategory = @getHighestAgeRestrictionCategory()

		if ageRestrictionCategory?.age_restriction?
			@ageRestrictionDescription = @translate('product.age_restriction.category.description', {
				categoryName: ageRestrictionCategory.name,
				value: ageRestrictionCategory.age_restriction
			})

	isVariantsTabDisabled: () ->
		return !@isVariantsEnabled || @isBundleProduct() || @isDepositProduct() || @isNonStockProduct()

	toggleTabs: () ->
		addonTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-product-addons')
		bundleTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-product-bundle')
		variantsTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-product-variants')
		productFilterTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-product-filter')
		productSuggestionTabIndex = @tabs.findIndex((tab) => tab.selector == '#tab-product-suggestion')

		@tabs[addonTabIndex].disabled = @isAddonsTabDisabled()
		@tabs[bundleTabIndex].disabled = @isBundledProductsTabDisabled()
		@tabs[variantsTabIndex].disabled = @isVariantsTabDisabled()
		@tabs[productFilterTabIndex].disabled = @isProductFilterTabDisabled()
		@tabs[productSuggestionTabIndex].disabled = @isProductSuggestionTabDisabled()

	mapProductFilterNames: (productFilters) ->
		for productFilter in productFilters
			if @productFilters[productFilter.product_filter_id]?
				productFilter.name = @productFilters[productFilter.product_filter_id].name

		return productFilters

	getDefaultUnit: ->
		return _.find @units, {default: '1'}

	showUnitPricing: ->
		return @isUnitPricingEnabled && !@isBundleProduct() && !@isDepositProduct() && !@isNonStockProduct()

	refreshActionButtons: ->
		@kibanaActionButton =
			action: 'kibana-sales'
			label: 'wbo.integration.elasticsearch.kibana.access'
			click: => @$window.open(@kibanaSalesUrl, '_blank', 'noopener,noreferrer')
		shouldShowKibanaButton = !_.isEmpty(@kibanaSalesUrl)
		@mainCrud.additionalButtons = _.without(@mainCrud.additionalButtons, @kibanaActionButton)
		@mainCrud.additionalButtons.push(@kibanaActionButton) if shouldShowKibanaButton

	initUnitData: ->
		@units = _.map(@units, (unit) =>
			# Mapping name is needed because 'not_set' unit (in ProductUnitData directive) has different id and name
			unit.name = unit.id

			return unit
		)

		@ProductUnitDataModalService = new ProductUnitDataModalService(
			@translate
			@product
			@unitId
			@attributesService
			@newVariant
			@units
			# setUnitDataProperties() is needed because the service can't set changed literal values
			(unitForSaleId, enableVariantsActualUnitData, productVariantActualUnits, variantUnitDataInfoMessage) =>
				@setUnitDataProperties(unitForSaleId, enableVariantsActualUnitData, productVariantActualUnits, variantUnitDataInfoMessage)
		)

		if !@showUnitPricing()
			return

		@ProductUnitDataModalService.initializeUnitData()
		@ProductUnitDataModalService.handleDataChanges()
		@ProductUnitDataModalService.persistData()

	setFormsDirty: ->
		@main_form.$setDirty true
		@separate_form.$setDirty true
		@mainCrud.parent_form.$setDirty true

	productVariantExternalAttributesInit: (variant) ->
		variant.attributeService = @EntityAttributeService.getNewInstance()
		variant
			.attributeService
			.setEntity(
				variant
				'BACKEND_PRODUCT_VARIANT_ATTRIBUTE_TYPE'
				{
					unit_id_actual: null
					unit_amount: null
					number_in_package: null
					carbon_footprint: null
				}
			)

	openUnitDataModal: ->
		@ProductUnitDataModalService.productUnitId = @unitId

		@$uibModal.open
			templateUrl: '@app/product/modals/product.unit-data.modal.view.html'
			controller: 'ProductUnitDataModalController'
			controllerAs: 'productUnitDataModal'
			bindToController: true
			size: 'lg'
			resolve:
				service: @ProductUnitDataModalService
				setFormsDirty: => => @setFormsDirty()

	openSkuModal: (entity, isVariant = false) ->
		@$uibModal.open
			templateUrl: '@app/product/modals/product.sku.modal.view.html'
			controller: 'ProductSkuModalController'
			controllerAs: 'productSkusModal'
			bindToController: true
			size: 'lg'
			resolve:
				entity: entity
				isVariant: isVariant
				setFormsDirty: => => @setFormsDirty()
				onSkuChange: => => @onSkuChange()
				getProductsWithDuplicateSkus: => => @productsWithDuplicateSkus

	showStocksModal: (stockValues, isVariant, name = '') ->
		@$uibModal.open
			templateUrl: '@app/product/modals/product.stock-value.modal.view.html'
			controller: 'ProductStockValueModalController'
			controllerAs: 'stockValuesModal'
			bindToController: true
			size: 'lg'
			resolve:
				showStocks: => isVariant || _.isEmpty(@product.product_variants)
				stockValues: => stockValues
				isVariant: => isVariant
				header: => "#{name} #{@translate('wbo.inventory.submenu.stocks')}"
				reasonCodes: => @reasonCodes
				onStockValueChange: =>
					return (stock) =>
						if angular.isUndefined(stock.min_quantity) || angular.isUndefined(stock.delta_quantity)
							return

						@setReasonCodes(stock)
						@setFormsDirty()

	showSupplierModal: (entity, isProduct) ->
		@$uibModal.open
			templateUrl: '@app/product/modals/product.supply.modal.view.html'
			controller: 'ProductSupplyModalController'
			controllerAs: 'supplyModal'
			bindToController: true
			size: 'lg'
			resolve:
				isProduct: => isProduct
				suppliers: => @suppliers
				productNumberInPackage: => @attributesService.attributes.number_in_package.value
				entity: => entity
				attributesService: => if isProduct then @attributesService else entity.attributeService
				onChange: => => @setFormsDirty()

	showPriceHistoryModal: (productVariantId = null) ->
		@$uibModal.open
			templateUrl: '@app/product/modals/product.price-history.modal.view.html'
			controller: 'ProductPriceHistoryModalController'
			controllerAs: 'priceHistoryModal'
			bindToController: true
			size: 'lg'
			resolve:
				productId: => @product.id
				productVariantId: => productVariantId
				priceRegions: => @priceRegions

	setUnitDataProperties: (unitForSaleId, enableVariantsActualUnitData, productVariantActualUnits, variantUnitDataInfoMessage) ->
		@unitId = unitForSaleId
		@enableVariantsActualUnitData = enableVariantsActualUnitData
		@productVariantActualUnits = productVariantActualUnits
		@variantUnitDataInfoMessage = variantUnitDataInfoMessage

	initProductSuggestions: ->
		if @product.product_suggestions.length <= 0
			return

		@ProductSuggestionService
			.initProductSuggestions(@product.product_suggestions)
			.then (productSuggestions) =>
				@product.product_suggestions = productSuggestions
				@sortProductSuggestions()

	addProductToSuggestions: (selectedProduct) ->
		selectedProduct.$wmSelectHidden = true
		@product.product_suggestions.push(
			@ProductSuggestionService.getNewProductSuggestionFromProduct selectedProduct
		)

	searchProductsForSuggestion: (searchString) ->
		@ProductRepository
			.searchProductsForSuggestion searchString
			.then (response) =>
				@searchData.suggestions = response

	removeProductFromSuggestion: (productSuggestion) ->
		_.find(@searchData.bundles, {id: productSuggestion.product_id})?.$wmSelectHidden = false

		@product.product_suggestions = _.without(@product.product_suggestions, productSuggestion)
		@setFormsDirty()

	sortProductSuggestions: ->
			# Sorting here instead of ng-repeat orderBy filter because, the filter sorts on input (instantly), we need on save
			@product.product_suggestions = _.sortBy(
				@product.product_suggestions,
				(productSuggestion) -> productSuggestion.name
			)

	getSuggestedProductSuggestions: ->
		@ProductRepository
			.findProductSuggestions(@product.id, @productSuggestionRecommendationCount)
			.then (products) =>
				if _.isEmpty(products)
					@ToastService.add(
						'general.product_suggestion_recommendations.not_found',
						'general.product_suggestion_recommendations',
						'general.error.not_found',
						'warning',
					)

					return

				suggestions = _.map(
					products,
					(product) => @ProductSuggestionService.getNewProductSuggestionFromProduct(product)
				)
				@product.product_suggestions.push(suggestions...)
				@setFormsDirty()

	onSkuChange: ->
		@ProductDuplicateSkuService
			.findProductsWithDuplicateSkusByProduct(@product, @newVariant, @isMultipleSkuEnabled)
			.then (data) =>
				@productsWithDuplicateSkus = data

	populateWithAllShops: ->
		@ShopRepository
			.list()
			.then (response) =>
				@product.shops = response.data
				@setFormsDirty()
